"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var MarkEditor_1 = __importDefault(require("../MarkEditor/MarkEditor"));
var IconEditor_1 = __importDefault(require("../IconEditor/IconEditor"));
var GraphicTypeField_1 = __importDefault(require("../Field/GraphicTypeField/GraphicTypeField"));
var SymbolizerUtil_1 = __importDefault(require("../../../Util/SymbolizerUtil"));
var antd_1 = require("antd");
var _get = require('lodash/get');
/** GraphicEditor to select between different graphic options */
var GraphicEditor = /** @class */ (function (_super) {
    __extends(GraphicEditor, _super);
    function GraphicEditor() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /**
         * Get the right Editor depending on kind of PointSymbolizer
         *
         * @param {PointSymbolizer} graphic Pointsymbolizer that should be editable
         * @param {any} iconEditorProps PassTroughProps for IconEditor
         * @return {React.ReactNode} MarkEditor or IconEditor or undefined
         */
        _this.getGraphicFields = function (graphic, iconEditorProps) {
            var _a = _this.props, onGraphicChange = _a.onGraphicChange, iconLibraries = _a.iconLibraries;
            if (_get(graphic, 'kind') === 'Mark') {
                var markGraphic = graphic;
                return (React.createElement(MarkEditor_1.default, { symbolizer: markGraphic, onSymbolizerChange: onGraphicChange }));
            }
            else if (_get(graphic, 'kind') === 'Icon') {
                return (React.createElement(IconEditor_1.default, __assign({ symbolizer: graphic, onSymbolizerChange: onGraphicChange, iconLibraries: iconLibraries }, iconEditorProps)));
            }
            else {
                return undefined;
            }
        };
        /**
         * If GraphicType changed, call props.onGraphicChange with default PointSymbolizers.
         * If GraphicType was unselected, call props.onGraphicChange with undefined to reset values.
         *
         * @param {GraphicType} gType currently selected GraphicType
         */
        _this.onGraphicTypeChange = function (gType) {
            var onGraphicChange = _this.props.onGraphicChange;
            if (onGraphicChange) {
                if (gType === 'Mark') {
                    onGraphicChange(SymbolizerUtil_1.default.generateSymbolizer('Mark'));
                }
                else if (gType === 'Icon') {
                    onGraphicChange(SymbolizerUtil_1.default.generateSymbolizer('Icon'));
                }
                else {
                    onGraphicChange(undefined);
                }
            }
        };
        return _this;
    }
    GraphicEditor.prototype.render = function () {
        var _a = this.props, graphic = _a.graphic, graphicType = _a.graphicType, graphicTypeFieldLabel = _a.graphicTypeFieldLabel, graphicTypeFieldProps = _a.graphicTypeFieldProps, iconEditorProps = _a.iconEditorProps;
        var formItemLayout = {
            labelCol: { span: 10 },
            wrapperCol: { span: 14 }
        };
        return (React.createElement("div", null,
            React.createElement(antd_1.Form.Item, __assign({ label: graphicTypeFieldLabel }, formItemLayout),
                React.createElement(GraphicTypeField_1.default, __assign({ graphicType: graphicType, onChange: this.onGraphicTypeChange }, graphicTypeFieldProps))),
            this.getGraphicFields(graphic, iconEditorProps)));
    };
    GraphicEditor.defaultProps = {
        graphicTypeFieldLabel: 'Graphic-Type'
    };
    return GraphicEditor;
}(React.Component));
exports.GraphicEditor = GraphicEditor;
exports.default = GraphicEditor;
//# sourceMappingURL=GraphicEditor.js.map